import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import { Styles, mergeSx } from '@t2c/shared-fe';
import Skeleton from '@mui/material/Skeleton';

interface Props extends DialogTitleProps {
  title: string;
  onClose?: () => void;
  rightIcon?: JSX.Element;
  showSkeletonLoader?: boolean;
  isInProgress?: boolean;
  showDivider?: boolean;
}

export const CustomDialogTitle = ({
  title,
  onClose,
  rightIcon,
  showSkeletonLoader,
  sx,
  children,
  isInProgress = false,
  showDivider = true,
  ...res
}: Props) => {
  return (
    <>
      <DialogTitle sx={mergeSx(styles.dialogTitle, sx)} {...res}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {showSkeletonLoader ? (
            <Skeleton height={40} width={'40%'} />
          ) : (
            <Typography sx={styles.title}>{title}</Typography>
          )}
          <Stack direction="row" alignItems="center" spacing={{ xs: 1, sm: 2 }}>
            {rightIcon}
            {!isInProgress && onClose && (
              <Tooltip title="Close">
                <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>
        {children}
      </DialogTitle>
      {showDivider && 
        <Divider sx={{ 
          width: '100%' ,
          borderColor: (theme) => theme.palette.background.border,
        }} 
      />}
    </>
  );
};

const styles: Styles = {
  dialogTitle: {
    px: 3,
    py: 2,
    color: (theme) => theme.palette.text.primary,
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
  },
  closeButton: {
    color: (theme) => theme.palette.text.primary,
    borderColor: (theme) => theme.palette.background.border,
    mr: -1,
  },
  divider: {
    backgroundColor: (theme) => theme.palette.background.border,
  },
};
